import React from "react";
import "./Home.css";
import { BiLogoGmail } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { FaInstagram } from "react-icons/fa";
import { FaDiscord } from "react-icons/fa";
import { renderStatementWithKaTeX } from "../../Status";
import AhmedMallek from "../Images/AhmedMallek.jpg";
import AwsDhahri from "../Images/AwsDhahri.jpg";
import OussemaSoussi from "../Images/OussemaSoussi.jpg";

const founders = [
  {
    role: "Founder",
    name: "Ahmed Mallek",
    age: 18,
    school: "Pioneer HighSchool Of Gabes",
    bio: "Former member of Tunisia’s IMO team with over 4 years of experience in math Olympiads. I founded MathTounsi not only to encourage students to pursue math Olympiads, but also to help them avoid the mistakes I made and the hardship of being stuck without proper resources.",
    archivement: [
      "PAMO Gold & Silver & Bronze",
      "2 x IMO participant",
      "3 x OFM Bronze",
    ],
    contributions: "Dev & Course management",
    email: "ahmedmallek2007@gmail.com",
  },
  {
    role: "Co-Founder",
    name: "Aws Dhahri",
    age: 18,
    school: "Pioneer HighSchool Of Monastir",
    bio: "I discovered my passion for problem-solving at the age of seven—a passion that grew over the years as I acquired more knowledge and skills, allowing me to progress from solving simple problems to competing in math Olympiads.",
    archivement: ["IMO partcipant","PAMO Gold & Silver", "AMO Gold", "OFM Bronze"],
    contributions: "Course management & Review",
    email: "dhaws07@gmail.com",
  },

  /*  {
    role: "Co-Founder",
    name: "Oussema Soussi",
    age: 19,
    school: "Pioneer HighSchool Of Tunis",
    bio: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus.",
    contributions: "Course management"
  } */
];

const Home = () => {
  const navigate = useNavigate();
  return (
    <div className="homepage">
      {/* Hero Section */}
      <section className="hero">
        <h1>📘 Master Math the Smart Way</h1>
        <p>
          Learn, practice, and excel with MathTounsi’s problem-solving approach.
        </p>
        <button className="cta-btn" onClick={() => navigate("/Login")}>
          Start Learning
        </button>

        {/* Floating Math Symbols */}
        <div className="math-symbols">
          <span className="floating-ahhh">
            {renderStatementWithKaTeX("$\\pi$")}
          </span>
          <span className="floating-ahhh">
            {renderStatementWithKaTeX("$\\sum$")}
          </span>
          <span className="floating-ahhh">
            {renderStatementWithKaTeX("$\\sqrt{}$")}
          </span>
          <span className="floating-ahhh">
            {renderStatementWithKaTeX("$\\infty$")}
          </span>
          <span className="floating-ahhh">
            {renderStatementWithKaTeX("$\\int$")}
          </span>
          <span className="floating-ahhh">
            {renderStatementWithKaTeX("$\\theta$")}
          </span>
        </div>
      </section>

      {/* What is MathTounsi Section */}
      <section className="about-mathtounsi">
        <h2>What is MathTounsi?</h2>
        <p>
          MathTounsi is an open-source, student-driven platform dedicated to
          supporting math learners, especially those preparing for math
          olympiads. Our mission is to make high-quality math resources,
          problem-solving exercises, and personalized guidance accessible to
          everyone, completely free of cost.
        </p>
        <p>
          It is a passion project made by <b>Tunisian students</b> with 
          3+ years of experience in math olympiads, that once struggled in this
          field, but are determined to share their expertise with brilliant
          young minds.
        </p>

        {/* Founder Cards */}
        <div className="founder-cards">
          {founders.map((founder, index) => (
            <div className="founder-card" key={index}>
              <img
                src={
                  founder.name === "Ahmed Mallek"
                    ? AhmedMallek
                    : founder.name === "Aws Dhahri"
                    ? AwsDhahri
                    : OussemaSoussi
                }
                alt=""
              />
              <h4>{founder.name}</h4>
              <p className="school">
                {founder.age} years old, {founder.school}
              </p>
              <h3>{founder.role}</h3>
              <p className="par">
                {" "}
                <strong>Contributions:</strong> {founder.contributions}
              </p>
              <p className="par">{founder.bio}</p>
              <ul style={{width: "35%", margin: "0 auto"}}>
                {founder.archivement.map((archivement) => (
                  <li>{archivement}</li>
                ))}
              </ul>
              <button className="email" onClick={()=>{window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${founder.email}`, "_blank")}}>
                <BiLogoGmail />
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* Features / Why Choose MathTounsi */}
      <section className="features">
        <h2>Why Choose MathTounsi?</h2>
        <p className="features-description">
          Our services include:{" "}
          <strong>
            creative courses in the resources section, daily problems, units
            covering a set of carefully labeled problems, personalized
            submission correction, and an enjoyable learning experience.
          </strong>
        </p>
        <div className="feature-cards">
          <div className="card">📚 Daily Problems</div>
          <div className="card">🧮 Step-by-Step guidance</div>
          <div className="card">🎯 Track Your Progress</div>
          <div className="card">👥 Join the Community</div>
        </div>
      </section>

      {/* Explore More MathTounsi */}
      <section className="popular">
        <h2>Explore More MathTounsi</h2>
        <div className="popular-cards">
          <div className="card" onClick={() => navigate("/ProblemOfTheDay")}>
            📅 Daily Problems
          </div>
          <div className="card" onClick={() => navigate("/Resources")}>
            📚 Resources
          </div>
          <div className="card" onClick={() => navigate("/OpenProblems")}>
            📝 Open Problems
          </div>
          <div className="card" onClick={() => navigate("/Games")}>
            🕹️ Games
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials">
        <h2>What Students Say</h2>
        <p>“MathTounsi helped me prepare for my exams with confidence!”</p>
        <p>“I love the daily problems, they keep me sharp.”</p>
      </section>

      {/* Tech Stack Section */}
      <section className="tech-stack">
        <h2>Join our Community on other Platforms</h2>
        <div className="tech-logos">
          <div className="SocialMedia-Slice">
            <FaInstagram className="SocialMEdia-Logo" />
            <p>{`Instagram : \n @MathTounsi`}</p>
          </div>
          <div className="SocialMedia-Slice">
            <FaDiscord className="SocialMEdia-Logo" />
            <p>{`Discord : \n MathTounsi`}</p>
          </div>
          
        </div>
      </section>

      {/* Final CTA */}
      <section className="final-cta">
        <h2>Ready to level up your math skills?</h2>
        <button className="cta-btn" onClick={() => navigate("/Login")}>
          Join MathTounsi
        </button>
      </section>
    </div>
  );
};

export default Home;
